<template>
  <Branding>
    <client-only>
      <div class="page-body">
        <SelfcareMobileHeader id="mobile-header" />
        <div class="side-bar flex-column">
          <SelfcareSideBar />
        </div>
        <div class="content">
          <SelfcareBreadcrumb id="breadcrumb" />
          <div
            class="content-body"
            data-scroll-container
          >
            <div class="scroll">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </client-only>
  </Branding>
</template>

<script setup>
import { useSelfcareStore } from "~~/stores/selfcare";
import {useSessionStore} from "~/stores/session";

const selfcareStore = useSelfcareStore();
const sessionStore = useSessionStore();

// Selfcare swaps views inside the layout instead of navigating, so every
// change of the active page or of the opened entity has to reset the scroll.
useScrollTopOnChange(() => [
  selfcareStore.activePage,
  selfcareStore.activePurchase?.id ?? null,
  selfcareStore.activeBusinessPurchase?.id ?? null,
  selfcareStore.activeTransaction?.id ?? null,
  selfcareStore.activeBusinessTransaction?.id ?? null,
  selfcareStore.activeTodo?.id ?? null,
].join("|"));
</script>

<style scoped lang="scss">
li::before {
  display: none;
}

.page-body {
  display: flex;
  flex-direction: row;
  flex: 1;

  .content-body {
    flex: 1;
    position: relative;
  }

  .content {
    display: flex;
    flex-direction: column;
    background: var(--gray50);
    flex: 1;
    position: relative;

    .content-body {
      position: relative;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      overflow: auto;

      .scroll {
        position: absolute;
        max-width: 100%;
        width: 792px;
        padding-bottom: 24px;
      }
    }
  }
}

@media only screen and (max-width: 1100px) {
  .side-bar {
    display: none;
  }

  #breadcrumb {
    display: none;
  }

  .page-body {
    flex-direction: column;
  }

  .content-body {
    margin-top: 0;
  }

  .scroll {
    padding: 32px 16px 16px 16px;
  }
}

@media only screen and (min-width: 1100px) {
  #mobile-header {
    display: none;
  }
}
</style>
